<<template>
<tr>
    <slot></slot>
    <th v-for='cl in config.listDefine' v-if='!cl.right || rights(cl.right)' 
    :class='[(!cl.type || cl.type=="sortClumn")? "sort-column":"default-column"]' 
    :style='"width:" + (cl.width? cl.width : "auto")'>
        <label v-if='cl.type=="selectClumn" && cl.selAll==true'><input type="checkbox" @change.stop="selAll($event,cl.keys)">{{getTitle(cl)}}</label>
        <a v-else 
        @click.stop='(!cl.type || cl.type=="sortClumn") && sort($event, cl)'>{{getContent(typeof cl == "string"? cl:cl.tkey || cl.key)}}</a>
        <span :class='sclass(cl.skey || cl.key || cl)' style="cursor: default;">{{getIndex(cl.skey || cl.key || cl)}}</span>
    </th>
</tr>
</template>
<script>
export default {
  props: ["config", "rs"],
  created: function() {},
  data() {
    return {
      currenCl: null
    }
  },
  methods: {
    getTitle(cl){
      const key = cl.tkey || cl.key || cl
      const str = this.rs[key]
      return str || key
    },
    getContent(key){
      const txt = this.rs[key]
      if (!txt) return key
      return txt
    },
    getIndex(key){
      const sorts = this.config.sorts
      if (sorts){
        for (let i=0; i<sorts.length;i++){
          if (sorts[i].key==key) {
            return i+1
          }
        }
      } 
      return null
    },
    sclass(key) {
      const sorts = this.config.sorts
      if (sorts){
        for (let i=0; i<sorts.length;i++){
          if (sorts[i].key==key) {
            return sorts[i].value == "asc" ? "sort-icon glyphicon glyphicon-sort-by-attributes" : "sort-icon glyphicon glyphicon-sort-by-attributes-alt"
          }
        }
      } 
      else if(this.config.sortName==key) return this.config.sortOrder == "asc" ? "sort-icon glyphicon glyphicon-sort-by-attributes" : "sort-icon glyphicon glyphicon-sort-by-attributes-alt"
      return "sort-icon"
    },
    isSortCL(key){
      const sorts = this.config.sorts
      if (sorts){
        for (let i=0; i<sorts.length;i++){
          if (sorts[i].key==key) return true
        }
      }
      else if (this.config.sortName == key) return true 
      return false
    },
    sort(e, cl) {
      const sf = cl.skey || cl.key || cl;


      if(e.ctrlKey){
        if (!this.config.sorts) this.config.sorts = [{key:this.config.sortName, value:this.config.sortOrder}]
        let sorts = this.config.sorts
        let tmp 
        let isNew = true
        for (let i=0; i<sorts.length; i++){
          tmp = sorts[i]
          if (tmp.key==sf){
            tmp.value = tmp.value == "asc" ? "desc" : "asc"
            isNew = false
          }
        }
        if (isNew) this.config.sorts.push({key:sf, value:"asc"})
      }
      else{
        this.config.sorts = null
        if (this.config.sortName == sf) this.config.sortOrder = this.config.sortOrder == "asc" ? "desc" : "asc";
        else this.config.sortOrder = "asc";
        this.config.sortName = sf;
      }
      //console.log(this.config.sorts)
      this.$loadData(this.config)
    },
    selAll(e, keys) {
      const rs = e.srcElement.checked
      this.config.list.forEach(d=>{
        d[keys] = rs
      })
      this.$set(this.config.list, 0, this.config.list[0])
    }
  }
};
</script>
